import { ClientCreate } from '@/features/dashboard/client/create/ClientCreate'
import { usePageTitle } from '@/hooks/usePageTitle'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_dashboard/clients/create')({
  component: RouteComponent,
})

function RouteComponent() {
  usePageTitle('顧客追加')
  return <ClientCreate />
}
